<template>
  <div>
    <div class="is-flex is-align-items-center is-justify-content-space-between">
      <p class="bold">חלון מספר 3 מתוך 3</p>
    </div>
    <div class="columns">
      <div class="column is-7">
        <div class="is-flex">
          <position-form-links style="text-align: center;" :position_id="payload.position.id" :company_id="payload.company_id" special="true"></position-form-links>
        </div>
        <div class="vertical_space"></div>
        <div class="vertical_space"></div>
        <p style="font-size: 24px;"><b>המשרה "{{payload.position.title}}" נוצרה בהצלחה!</b></p>
        <div class="vertical_space"></div>
        <div>
          <div style="margin-top: 20px;">
            <div class="is-flex is-align-items-center">
              <input class="outlined" v-model="position_title">
              <div class="horizontal_space"></div>
              <a @click="changePositionTitle()" class="button is-info" :class="{ 'is-loading': is_changing_title }">שנה שם משרה</a>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="is-flex text_align_left is-justify-content-center is-flex-direction-column">
          <p class="mx-3"><b>TO DO:</b></p>
          <div class="vertical_space"></div>
          <div @mouseover="openModal('Questions')" @mouseleave="removeModal('Questions')" class="is-flex is-justify-content-end">
            <div class="mx-3">Questions</div>
            <checkbox v-model="is_questions_done"></checkbox>
          </div>
          <div class="vertical_space"></div>
          <div class="vertical_space"></div>
          <div @mouseover="openModal('Skills')" @mouseleave="removeModal('Skills')" class="is-flex is-justify-content-end">
            <div class="mx-3">Skills</div>
            <checkbox v-model="is_skills_done"></checkbox>
          </div>
          <div class="vertical_space"></div>
          <div class="vertical_space"></div>
          <div @mouseover="openModal('Locations')" @mouseleave="removeModal('Locations')" class="is-flex is-justify-content-end">
            <div class="mx-3">Locations</div>
            <checkbox v-model="is_locations_done"></checkbox>
          </div>
          <div class="vertical_space"></div>
          <div class="vertical_space"></div>
          <div @mouseover="openModal('Texts')" @mouseleave="removeModal('Texts')" class="is-flex is-justify-content-end">
            <div class="mx-3">Texts</div>
            <checkbox v-model="is_texts_done"></checkbox>
          </div>
          <div class="vertical_space"></div>
          <div class="vertical_space"></div>
          <div @mouseover="openModal('RelatedOffers')" @mouseleave="removeModal('RelatedOffers')" class="is-flex is-justify-content-end">
            <div class="mx-3">Connected Offers</div>
            <img @click="showConnectedPositionManager()" class="btn" src="/group.svg" width="30px">
            <div class="horizontal_space"></div>
            <checkbox v-model="is_related_offers"></checkbox>
          </div>
          <div class="vertical_space"></div>
          <div class="vertical_space"></div>
          <div class="is-flex is-justify-content-end is-align-items-center">
            <a
              @click="activatePosition"
              class="button is-success is-outlined mx-3"
              :class="{ 'is-loading': is_activating_position, faded: !is_finished_tasks || is_position_activated }">
              {{ is_position_activated ? 'Activated' : 'Activate Position' }}
            </a>
            <checkbox v-model="isActivated"></checkbox>
          </div>
          <div class="vertical_space"></div>
          <div class="vertical_space"></div>
          <div class="is-flex is-justify-content-end is-align-items-center">
            <is-hot :payload="payload.position" class="mx-4" :class="{ faded: !is_position_activated }"></is-hot>
            <checkbox v-model="is_flame"></checkbox>
          </div>
          <div class="vertical_space"></div>
          <div class="vertical_space"></div>
          <div class="is-flex is-justify-content-end is-align-items-center">
            <a @click="createPost" class="button is-info mx-3">Create Post</a>
            <checkbox v-model="is_create_post"></checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_footer is-justify-content-center">
      <div class="is-flex is-justify-content-space-around">
        <div>
          <a
            @click="closeTheModal"
            class="button is-info mx-3"
            >לא צריך לעבוד על המשרה עכשיו</a
          >
        </div>
        <div>
          <a
            @click="redirectToMission"
            class="button is-info mx-3"
            >שייכי למגייסת אחרת</a
          >
        </div>
        <div>
          <a
            @click="redirectToOffers"
            class="button is-info mx-3"
            >שייכו אליי את המשרה עכשיו</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import PositionFormLinks from '@/components/PositionFormLinks'
import Checkbox from '@/components/Checkbox'
import IsHot from '@/components/IsHot'
import { bus } from '@/custom/classes/bus.js'
export default {
  name: 'create-positions-step-three',
  props: ['payload'],
  data () {
    return {
      position_title: this.payload.position.title,
      is_position_activated: false,
      is_changing_title: false,
      is_activating_position: false,
      is_questions_done: false,
      is_skills_done: false,
      is_locations_done: false,
      is_texts_done: false,
      is_related_offers: false,
      isActivated: false,
      is_flame: false,
      is_create_post: false
    }
  },
  computed: {
    is_finished_tasks () {
      return this.is_questions_done && this.is_skills_done && this.is_locations_done && this.is_texts_done && this.is_related_offers && this.isActivated
    },
    ...mapGetters('modals', ['findModal'])
  },
  created () {
    this.sendPositionCreatedStat()
  },
  methods: {
    redirectToOffers () {
      this.createDesignatorPosition()
    },
    redirectToMission () {
      this.createDesignatorPosition({ owner: 'NULL' })
    },
    closeTheModal () {
      this.createDesignatorPosition({ owner: 'NULL', priority: 80 })
    },
    createDesignatorPosition ({ priority, owner } = {}) {
      this.create({
        designator: 'alert-form-modal',
        component_name: 'AlertForm',
        is_create: true,
        data: this.payload,
        init_designator: 'designated_position',
        init_priority: priority || 90,
        init_owner: owner || this.$utils.getOwner().name,
        resource_type: 'Position',
        resource_id: this.payload.position.id,
        modal_title: 'Create new Alert',
        suitcase: true,
        props: {
          onSubmit: () => {
            this.removeModalById(this.payload.modal_id)
          }
        }
      })
    },
    sendPositionCreatedStat () {
      this.$network_utils.postStat({
        resource_type: 'Position',
        resource_id: this.payload.position.id,
        priority: 5,
        owner: this.$utils.getOwner().name,
        title: 'Position Created',
        designator: 'position_created',
        content: 'Position Created',
        status: 'done'
      })
    },
    openModal (resource) {
      let modal = this.findModal({ type: 'designator', value: 'position-' + resource.toLowerCase() + '-modal' })
      if (modal != undefined) {
        return
      }
      this.create({ designator: 'position-' + resource.toLowerCase() + '-modal', component_name: 'Position' + resource, position_id: this.payload.position.id, company_id: this.payload.company_id, position_data: this.payload.position, modal_title: 'Position ' + resource })
    },
    removeModal (resource) {
      let modal = this.findModal({ type: 'designator', value: 'position-' + resource.toLowerCase() + '-modal' })
      this.remove(modal)
    },
    activatePosition () {
      this.is_activating_position = true
      this.$network_utils.updatePosition({ position_id: this.payload.position.id, current_company_id: this.payload.company_id, status: 'active' }).then(() => {
        this.regenerateOffers()
        this.$network_utils.refreshPublicPositions()
        this.$utils.emit('show_toast', { text: 'המשרה הופעלה בהצלחה' })
        this.is_activating_position = false
        this.is_position_activated = true
        bus.$emit('position_status_changed', { position_id: this.payload.position.id, status: 'active' })
      }).catch(() => {
        this.is_activating_position = false
        this.$utils.emit('show_toast', { text: 'ארעה שגיאה' })
      })
    },
    regenerateOffers () {
      this.$network_utils.sendPositionUpdateEvent({
        company_id: this.payload.company_id,
        position_id: this.payload.position.id
      })
    },
    showConnectedPositionManager () {
      let data = this.payload.position
      this.create({ designator: 'connected-position-manager-modal', component_name: 'ConnectedPositionManager', position: data, modal_title: data.title + ' - Connected Position Manager', is_center_modal: true, modal_width: 1400 })
    },
    changePositionTitle () {
      this.is_changing_title = true
      this.$network_utils.updatePosition({
        position_id: this.payload.position.id,
        current_company_id: this.payload.company_id,
        title: this.position_title
      }).then(response => {
        this.$utils.emit('show_toast', { text: `שם המשרה השתנה ל- ${response.title} בהצלחה!` })
        this.is_changing_title = false
      })
    },
    createPost () {
      this.create({
        designator: 'create-position-post-form',
        component_name: 'CreatePositionPostForm',
        position_id: this.payload.position.id,
        modal_title: 'Create Position Post - ' + this.payload.position.title,
        is_center_modal: true,
        modal_width: 1700
      })
    },
    ...mapMutations('modals', ['remove', 'removeModalById', 'create'])
  },
  components: {
    PositionFormLinks,
    Checkbox,
    IsHot
  }
}
</script>
